<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="TOC">Contents</h1>
<p class="toc1" style="margin-top:20px;"><a href="#/4chap1#chap1">TALKING DOG</a></p>
<p class="toc1"><a href="#/5chap2#chap2">CAULIFLOWER HEADS</a></p>
<p class="toc1"><a href="#/6chap3#chap3">RUBBER LIFE</a></p>
<p class="toc1"><a href="#/7chap4#chap4">AMAZING</a></p>
<p class="toc1"><a href="#/8chap5#chap5">GHIRLANDAIO</a></p>
<p class="toc1"><a href="#/9chap6#chap6">AMATEUR VOODOO</a></p>
<p class="toc1"><a href="#/10chap7#chap7">POTATO WORLD</a></p>
<p class="toc1"><a href="#/11chap8#chap8">DOG STORIES</a></p>
<p class="toc1"><a href="#/12chap9#chap9">IMAGINARY PROBLEMS</a></p>
<p class="toc1"><a href="#/13chap10#chap10">THE SHINING PATH</a></p>
<p class="toc1"><a href="#/14chap11#chap11">HANSEL AND GRETEL</a></p>
<p class="toc1" style="margin-top:20px;"><a href="#/15about#about">About the Author</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3-TOC.vue?3a60880a